import { render, staticRenderFns } from "./UniversalTable.vue?vue&type=template&id=7799c1a9"
import script from "./UniversalTable.vue?vue&type=script&lang=js"
export * from "./UniversalTable.vue?vue&type=script&lang=js"
import style0 from "./UniversalTable.vue?vue&type=style&index=0&id=7799c1a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports